import { Dialog, DialogClose, DialogContent, DialogTitle } from "@/components/ui/dialog/dialog";

import type { ComponentProps } from "react";

type Props = {
	open: ComponentProps<typeof Dialog>["open"];
	handleOpenChange: ComponentProps<typeof Dialog>["onOpenChange"];

	handleClickCloseButton: ComponentProps<typeof DialogClose>["onClick"];

	children: React.ReactNode;
};

export const DialogSnackLayoutSettings = ({ open, handleOpenChange, handleClickCloseButton, children }: Props) => {
	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogClose onClick={handleClickCloseButton} />

			<DialogContent>
				<DialogTitle>レイアウト設定</DialogTitle>

				{children}
			</DialogContent>
		</Dialog>
	);
};

DialogSnackLayoutSettings.displayName = "DialogSnackLayoutSettings";
